import { nlToBr } from "@/src/helpers";
import { IWPImage } from "@/src/types";
import { MainInner } from "@/styles/global";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { AnimationOnScroll } from "react-animation-on-scroll";

import React from "react";
import S from "./ImageTextBlock.styled";

export interface Props {
  animation: string;
  title: string;
  text: string;
  image: IWPImage;
  mediaType: "image" | "video";
  vimeo?: string;
}

const ImageTextBlock: React.FC<Props> = ({
  animation,
  title,
  text,
  image,
  mediaType,
  vimeo,
}) => {
  const ImageData = image?.localFile?.childImageSharp?.gatsbyImageData
    ? getImage(image.localFile.childImageSharp.gatsbyImageData)
    : null;
  return (
    <AnimationOnScroll
      animateIn={`animate__${animation}`}
      animateOnce={true}
      initiallyVisible={animation == "none" ? true : false}
      duration={animation === "none" ? 0 : 1}
      delay={animation === "none" ? 0 : 100}
    >
      <MainInner>
        <S.Container>
          <S.ImageWrapper>
            {ImageData && mediaType === "image" && (
              <S.Image image={ImageData} alt={image.altText || ""} />
            )}
            {vimeo && mediaType === "video" && (
              <div
                className="vimeo"
                dangerouslySetInnerHTML={{ __html: vimeo }}
              />
            )}
          </S.ImageWrapper>
          <S.TextWrapper>
            <S.Title>{title}</S.Title>
            <S.Text>{nlToBr(text)}</S.Text>
          </S.TextWrapper>
        </S.Container>
      </MainInner>
    </AnimationOnScroll>
  );
};

export default ImageTextBlock;
